import styled from 'styled-components';
import { CssRule } from '../../../../../themes/architecture/css-helpers/css-rule';

export const IntermediatePageDefaultBox = styled.div`
     position: relative;
     width: 100%;
     height: 100%;
     background-image: url(${props => props.theme.images.texture.toString()});     
     ${CssRule.For.mobile.tablet.build()} & {
        max-width: 54rem;
        height: auto;
     }
     
`;

